/** Portal target for API-key modals opened from WorkspaceSettingsModal (above `#settings-modal`). */
export const API_KEYS_MODAL_WRAPPER_ID = 'api-keys-modal';
